import React from 'react';
import { Container, Typography, Link, Box, Divider } from '@mui/material';

const Policy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom>
        プライバシーポリシー
      </Typography>

      {/* Cookieの使用 */}
      <Typography variant="h6" gutterBottom>
        Cookieの使用について
      </Typography>
      <Typography paragraph>
        本アプリでは、Googleを含む第三者配信事業者が Cookie を使用して、過去のアクセス情報に基づき広告を配信しています。
        ユーザーは<a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">広告設定</a>でパーソナライズ広告を無効にできます。
      </Typography>

      {/* アクセス解析ツール */}
      <Typography variant="h6" gutterBottom>
        アクセス解析ツールについて
      </Typography>
      <Typography paragraph>
        本アプリでは、Google アナリティクスを使用しています。
        このツールは、トラフィックデータの収集のために Cookie を使用していますが、このデータは匿名で収集され、個人を特定するものではありません。
        詳しくは<a href="https://marketingplatform.google.com/about/analytics/terms/jp/" target="_blank" rel="noopener noreferrer">Google アナリティクス利用規約</a>をご参照ください。
      </Typography>

      {/* 広告について */}
      <Typography variant="h6" gutterBottom>
        広告配信について
      </Typography>
      <Typography paragraph>
        本アプリでは、Google AdSense による広告配信を行っています。
        広告配信事業者は、ユーザーの興味に応じた広告を表示するために Cookie を使用することがあります。
        <a href="https://policies.google.com/technologies/ads?hl=ja" target="_blank" rel="noopener noreferrer">Googleの広告に関するポリシー</a>をご確認ください。
      </Typography>

      {/* 個人情報の取り扱い */}
      <Typography variant="h6" gutterBottom>
        個人情報の取り扱い
      </Typography>
      <Typography paragraph>
        本アプリでは、お問い合わせ時にメールアドレスなどの個人情報をご提供いただく場合がありますが、これらはお問い合わせへの対応にのみ使用します。
      </Typography>

      {/* 免責事項 */}
      <Typography variant="h6" gutterBottom>
        免責事項
      </Typography>
      <Typography paragraph>
        本アプリのコンテンツは可能な限り正確な情報を掲載するよう努めていますが、正確性や安全性を保証するものではありません。
        万が一、本アプリの情報により生じた損害等については一切の責任を負いかねますのでご了承ください。
      </Typography>

      <Divider sx={{ my: 4 }} />

      {/* お問い合わせ */}
      <Typography variant="h6" gutterBottom>
        お問い合わせ
      </Typography>
      <Typography paragraph>
        ご不明点がある場合は、以下までご連絡ください：
      </Typography>
      <Link href="mailto:contact@example.com" color="primary">
        sekkeiyanosagyoubeya@gmail.com
      </Link>

      {/* 広告エリア */}
      <Box sx={{ my: 5, textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary">
          広告エリア（AdSenseコードをここに配置）
        </Typography>
      </Box>
    </Container>
  );
};

export default Policy;
